import {FC} from 'react';
import BaseNavigationTabs from 'components/Navigation/BaseNavigationTabs';
import BaseNavigationTabsButton from 'components/Navigation/BaseNavigationTabs/BaseNavigationTabsButton';
import {NavigationTabsPropsHelper} from 'components/Navigation/BaseNavigationTabs/types';
import {c} from 'ttag';

const NavigationTabsDocumentSettings: FC<NavigationTabsPropsHelper> = ({
    className,
    selection,
}) => (
    <BaseNavigationTabs className={className} selection={selection}>
        <BaseNavigationTabsButton
            href={window.Urls.preset_list_view()}
            label={c('component').t`Document Presets`}
            name="documentPresets"
        />
        <BaseNavigationTabsButton
            href={window.Urls.numbering_settings_view()}
            label={c('component').t`Numbering`}
            name="numbering"
        />
        <BaseNavigationTabsButton
            href={window.Urls.approval_settings_view()}
            label={c('component').t`Approval`}
            name="documentApproval"
        />
        <BaseNavigationTabsButton
            href={window.Urls.partner_tags_view()}
            label={c('component').t`Tags`}
            name="tags"
        />
        <BaseNavigationTabsButton
            href={`${window.Urls.customtemplate_list_view()}?filter_form=filter_all&state=notarchived`}
            label={c('component').t`Custom Templates`}
            name="customTemplates"
        />
        <BaseNavigationTabsButton
            href={window.Urls.extendeddatafields_list_view()}
            label={c('component').t`Extended Data Fields`}
            name="extendedDataFields"
        />
        <BaseNavigationTabsButton
            href={window.Urls.settings_document_conversion_view()}
            label={c('component').t`Conversion`}
            name="conversionSettings"
        />
        <BaseNavigationTabsButton
            href={window.Urls.react_tax_registration_number_view()}
            label={c('component').t`TRN Display`}
            name="taxRegistrationNumber"
        />
        <BaseNavigationTabsButton
            href={window.Urls.pdf_filename_settings_view()}
            label={c('component').t`PDF Filename`}
            name="pdfFilenameSettings"
        />
    </BaseNavigationTabs>
);

export default NavigationTabsDocumentSettings;
